"use strict";
// Copyright (c) 2021-2024, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const cdn_1 = require("../helpers/cdn");
const buffer_1 = require("../modules/buffer");
($ => {
    const setup = () => {
        $.fn.qrCode = function (text_1) {
            return __awaiter(this, arguments, void 0, function* (text, options = {}) {
                var _a;
                const $this = $(this);
                (_a = options.size) !== null && _a !== void 0 ? _a : (options.size = $this.width());
                if ($this.is('img') || $this.is('canvas')) {
                    options.format = 'png';
                }
                else if ($this.is('svg')) {
                    options.format = 'svg';
                }
                else {
                    throw new Error('Unsupported element for QR Code');
                }
                const code = window.QRCode(text, options);
                const response = yield $.fetch(code.base_url, {
                    method: 'POST',
                    json: code.options
                });
                if (!response.ok) {
                    throw new Error('Could not fetch QR Code Image');
                }
                const blob = yield response.blob();
                const buffer = buffer_1.Buffer.from(yield blob.arrayBuffer(), blob.type);
                if (options.format === 'png' && $this.is('img')) {
                    return new Promise((resolve, reject) => {
                        $this.attr('src', buffer.toString('inline-base64'))
                            .one('load', () => resolve($this))
                            .one('error', () => reject(new Error('An unknown error occurred')));
                    });
                }
                else if (options.format === 'svg' && $this.is('svg')) {
                    const elem = $(buffer.toString());
                    const elem_attrs = (() => {
                        const attributes = [];
                        $.each(elem.element().attributes, function () {
                            if (this.name === 'width' || this.name === 'height')
                                return;
                            attributes.push([this.name, this.value]);
                        });
                        return attributes;
                    })();
                    // copy the current element's attributes to our new element
                    $.each($this.element().attributes, function () {
                        elem.attr(this.name, this.value);
                    });
                    // copy back over the new elements attributes
                    for (const [name, value] of elem_attrs) {
                        elem.attr(name, value);
                    }
                    $this.replaceWith(elem);
                    return elem;
                }
                else if (options.format === 'png' && $this.is('canvas')) {
                    return new Promise((resolve, reject) => {
                        const image = new Image();
                        image.src = buffer.toString('inline-base64');
                        image.onerror = (_event, _source, _lineno, _colno, error) => {
                            if (error) {
                                return reject(error);
                            }
                            return reject(new Error('An unknown error occurred'));
                        };
                        image.onload = () => {
                            const canvas = $this.element();
                            const context = canvas.getContext('2d');
                            if (!context) {
                                return reject(new Error('Could not get canvas 2d context'));
                            }
                            const scale = Math.min(canvas.width / image.width, canvas.height / image.height);
                            const [x, y] = [
                                (canvas.width - image.width * scale) / 2,
                                (canvas.height - image.width * scale) / 2
                            ];
                            context.clearRect(0, 0, canvas.width, canvas.height);
                            context.drawImage(image, 0, 0, image.width, image.height, x, y, image.width * scale, image.height * scale);
                            return resolve($this);
                        };
                    });
                }
                else {
                    throw new Error('Unsupported element type');
                }
            });
        };
    };
    if (typeof window.QRCode === 'undefined') {
        $.getScript({
            url: `${cdn_1.JSDELIVR}/@gibme/qrcode@${(0, cdn_1.version)('@gibme/qrcode')}/dist/QRCode.bundle.js`,
            cache: true,
            success: () => setup()
        });
    }
    else {
        setup();
    }
})(window.$);
//# sourceMappingURL=qrcode.js.map